import React from 'react';
import {Button, TextButton} from '@wix/wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../Widget/ControllerContext';
import {NoOnlineOrdersMessageDataHooks} from './NoOnlineOrdersMessage';

interface NoOnlineOrdersActionsProps {
  onDismissNoPremiumError: () => void;
}

export const NoOnlineOrdersActions = ({onDismissNoPremiumError}: NoOnlineOrdersActionsProps) => {
  const {
    navigationStore: {upgradeUrlWithModalReferral},
  } = useControllerProps();
  const localeKeys = useLocaleKeys();

  return (
    <>
      <Button
        as={'a'}
        data-hook={NoOnlineOrdersMessageDataHooks.CtaButton}
        href={upgradeUrlWithModalReferral}
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          e.stopPropagation();
          window.open(upgradeUrlWithModalReferral, '_blank');
        }}
        upgrade>
        {localeKeys.checkout.noPremiumMerchant.merchantCheckoutUnavailable.cta.$value()}
      </Button>
      <TextButton data-hook={NoOnlineOrdersMessageDataHooks.SecondaryLink} onClick={onDismissNoPremiumError}>
        {localeKeys.checkout.noPremiumMerchant.merchantCheckoutUnavailable.cta.secondary()}
      </TextButton>
    </>
  );
};
